<template functional>
  <div class="w-full py-6 box-border relative">
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
      样本服务流程：
    </header>
    
    <div class="flex mt-2">
      <div class="ball">1</div>
      <div class="title">扫码添加客服</div>
    </div>
    <div class="flex">
      <div class="line"></div>
      <div class="flex pt-1 pb-4">
        <img src="/assets/img/code/Mrs.Chai.png" class="normal-img"/>
        <div class="ml-3 flex-1 text-small flex flex-col justify-center">
          <p class="w-full leading-22">
            <span class="text-theme-black-450">客服顾问：</span>
            <span class="text-theme-black-850">柴女士</span>
          </p>
          <p class="w-full leading-22">
            <span class="text-theme-black-450">联系电话：</span>
            <span class="text-theme-black-850">18511821229</span>
          </p>
        </div>
      </div>
    </div>
    <div class="flex mt-2 ml-px">
      <div class="ball">2</div>
      <div class="title">告知所需样本</div>
    </div>
    <div class="line h-18"></div>
    <div class="flex mt-2 ml-px">
      <div class="ball">3</div>
      <div class="title">客服人工报价</div>
    </div>
    <div class="line h-18"></div>
    <div class="flex mt-2 ml-px">
      <div class="ball">4</div>
      <div class="title">在线支付费用</div>
    </div>
    <div class="line h-18"></div>
    <div class="flex mt-2 ml-px">
      <div class="ball">5</div>
      <div class="title">平台定向推送{{'问卷' | replaceText(props.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes(props.scene)?1:0)}}</div>
    </div>
    <div class="line h-18"></div>
    <div class="flex mt-2 ml-px">
      <div class="ball">6</div>
      <div class="title">审核确认答卷</div>
    </div>
    <div class="line h-18"></div>
    <div class="flex mt-2 ml-px">
      <div class="ball">7</div>
      <div class="title">客服开具发票</div>
    </div>
    <div class="absolute bottom-0 w-full h-px px-6 box-border" v-if="props.border">
      <div class="w-full f-full border-b border-solid border-border-gray" />
    </div>
  </div>
</template>

<script>
import { propMixins } from '@/mixins/publish';

export default {
  name: 'SampleContactService',
  // functional: true,
  mixins: [propMixins],
  props: {
    baseUrl: {
      type: String,
      default: '/',
    },
    scene: {
      type: String,
      default: 'Default',
    }
  }
}
</script>

<style scoped lang="scss">
.ball {
  @apply w-4 h-4 rounded-full text-white text-small font-bold text-center ml-4;
  line-height: 16px;
  background: #1890FF;
}
.title {
  @apply text-theme-black-850 text-medium ml-2;
  font-family: PingFangSC-Regular;
  line-height: 14px;
}
.line {
  @apply w-px opacity-20 bg-white border-l border-dashed border-theme ml-6 mr-4 -mb-2;
}
.h-18 {
  height: 18px;
}
</style>